import Invites from 'components/Invites';

const InvitesPage = () => {
  return <Invites />;
};

export default InvitesPage;
